export { WarehousesView } from './WarehousesView';
